<template>
  <div class="register">
    <div class="container">
      <div class="content">

            <div class="formWrap">
              <div class="inlineBlockWrap">
                <div class="inlineBlock myBar">
                  <p class="registerTitle">欢迎使用龙腾之星</p>
                  <div class="center">
                    <div class="tabTitle">
                      <span class="titleItem"
                        :class="{'titleActive': loginWay=='pwd'}"
                        @click="changeWay('pwd')">账号密码登录</span>
                      <span class="titleItem"
                        :class="{'titleActive':
                        loginWay=='msg'}"
                        @click="changeWay('msg')">短信验证码登录</span>
                    </div>
                  </div>
                  <Form ref="login" :model="info" hide-required-mark class="formStyle">

                    <template v-if="loginWay=='msg'">
                      <FormItem prop="loginName" label="手机号码" :rules="loginNameRules">
                        <Input type="tel" v-model="info.loginName"></Input>
                      </FormItem>
                      <FormItem key="msg" prop="key1" label="短信验证码">
                        <Input type="text" class="msgCodeInput" v-model="info.key1" @on-enter="login"></Input>
                        <Button shape="circle" :disabled="codeBtnText!='获取验证码'" class="defaultBtn msgCodeBtn" @click="sendMsgCode">{{codeBtnText}}</Button>
                      </FormItem>
                    </template>
                    <template v-if="loginWay=='pwd'">
                      <FormItem prop="loginName" label="用户名" >
                        <Input type="text" v-model="info.loginName"></Input>
                      </FormItem>
                      <FormItem key="pwd" prop="key2" label="登录密码" :rules="keyRules">
                        <Input type="password" v-model="info.key2" @on-enter="login"></Input>
                      </FormItem>
                    </template>
                  </Form>
                  <Button shape="circle" long :loading="submitting" class="defaultBtn" @click="login">登录</Button>
                  <div class="clearfix">
                    <router-link :to="'/register?fromUrl='+this.$route.query.fromUrl" class="blackHref">还没有账号，去注册</router-link>
                    <router-link :to="'/reset_password?fromUrl='+this.$route.query.fromUrl" class="floatRight blackHref">找回密码</router-link>
                  </div>
                  <!-- <Divider class="lightColor" size="small">合作机构账号登录</Divider> -->
                </div>
              </div>
            </div>

      </div>
    </div>
  </div>
</template>

<script>
import centerService from "@/api/center";
export default {
  name: "Index",
  data() {
    return {
      loginWay: "pwd",
      info: {},
      loginNameRules: [
        {
          required: true,
          pattern: /^1[3456789]\d{9}$/,
          message: "请输入手机号码",
          trigger: "blur"
        }
      ],
      keyRules: [
        { required: true, message: "内容不能为空", trigger: "blur,change" }
      ],
      submitting: false,
      codeBtnText: "获取验证码"
    };
  },
  mounted() {},
  methods: {
    // 更换登录方式
    changeWay(val) {
      if (this.loginWay == val) {
        return;
      }
      this.info.key = null;
      this.loginWay = val;
    },
    // 登录
    login() {
      this.$refs.login.validate(valid => {
        if (valid) {
          this.submitting = true;
          let condition = { loginName: this.info.loginName };
          if (this.loginWay == "pwd") {
            condition.key = this.info.key2;
          }
          if (this.loginWay == "msg") {
            condition.key = this.info.key1;
          }
          condition.accountType = "DESIGNER";
          centerService
            .login(condition)
            .then(res => {
              if (res.errorNo == 0) {
                this.$store.commit("setToken", res.data.accessToken);
                let user = res.data.user;
                this.$store.commit("setUserInfo", user);
                window.localStorage.setItem("login_time", new Date().getTime());
                // 跳转到什么页面
                // let fromUrl = this.$route.query.fromUrl || '/dragon_star/index'
                let fromUrl = this.$route.query.fromUrl;
                fromUrl == "undefined" && (fromUrl = null);
                fromUrl = fromUrl || "/personal_info";
                if (
                  fromUrl.indexOf("ddf_vote") < 0 &&
                  fromUrl.indexOf("top_events") < 0
                ) {
                  if (res.data.user.userStatus == "REGISTERING") {
                    fromUrl = "/register";
                  }
                }
                this.$router.push(fromUrl);
                // this.$Message.info({content:'为了更好的使用体验，建议您使用谷歌浏览器且勿使用无痕模式。',duration:3})
                // this.$Modal.info({
                //   title: '友情提示',
                //   content: '为了更好的使用体验，建议您使用谷歌浏览器且勿使用无痕模式。'
                // });
                let ua = navigator.userAgent;
                // console.log(ua)
                let browserSupport = false;
                if (
                  ua.indexOf("Chrome") > -1 ||
                  ua.indexOf("Safari") > -1 ||
                  ua.indexOf("Firefox") > -1
                ) {
                  browserSupport = true;
                }
                if (!browserSupport) {
                  this.$Modal.info({
                    title: "友情提示",
                    content:
                      "为了更好的使用体验，建议您使用谷歌浏览器且勿使用无痕模式。国产浏览器建议使用极速模式不要使用兼容模式。"
                  });
                } else {
                  // this.$Message.info({content:'为了更好的使用体验，建议您使用谷歌浏览器且勿使用无痕模式。',duration:3})
                }
              } else {
                // this.$Message.error(res.errorMessage)
                // this.$Message.error('用户不存在或密码错误')
                if (res.errorNo == 9013) {
                  if (
                    res.errorMessage.split(",").length > 1 &&
                    res.errorMessage.split(",")[0] == 5054
                  ) {
                    this.$Message.error("用户不存在");
                  } else {
                    this.$Message.error("密码错误");
                  }
                } else {
                  this.$Message.error(res.errorMessage);
                }
              }
              this.submitting = false;
            })
            .catch(err => {
              this.submitting = false;
              // this.$Message.error(err.message)
              console.log(err.message);
              this.$Message.error("连接服务器失败，请稍后再试");
            });
        } else {
          this.$Message.error("请输入正确的手机号和密码(验证码)");
        }
      });
    },
    // 获取验证码
    sendMsgCode() {
      this.$refs.login.validateField("loginName", valid => {
        if (valid) {
          this.$Message.error("请输入正确的手机号");
        } else {
          let condition = {
            smsType: "LOGIN",
            mobilePhone: this.info.loginName
          };
          let timer = null;
          centerService.sendCaptcha(condition).then(res => {
            if (res.errorNo == 0) {
              let time = 60,
                _this = this;
              timer = setInterval(function() {
                time--;
                _this.codeBtnText = `获取验证码${time}`;
                if (time == 0) {
                  clearInterval(timer);
                  _this.codeBtnText = "获取验证码";
                }
              }, 1000);
            } else {
              this.$Message.error(res.errorMessage);
            }
          });
          this.$once("hook:beforeDestroy", () => {
            clearInterval(timer);
            this.codeBtnText = "获取验证码";
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .register {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    padding: 2rem;
    min-height: 100vh;
    box-sizing: border-box;

    .container {
      height: 100%;
      max-width: 1200px;
      margin: 0 auto;
    }

    .content {
      position: relative;
      border-radius: 15px;
      height: auto;
      min-height: 500px;
      background: #ffffff;
      padding: 2rem;
      box-shadow: 0 10px 30px rgba(76, 175, 80, 0.1);
      margin: 0 auto;

      .height {
        height: auto;
      }

      .formWrap {
        position: relative;
        background: #ffffff;
        overflow: hidden;
        border-top: 4px solid #4CAF50;
        border-radius: 8px;
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 2rem;

        .inlineBlockWrap {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          transition: transform 0.3s;
        }

        .inlineBlock {
          flex: 0 0 100%;
          max-width: 100%;
          padding: 1rem;
          transition: opacity 0.3s;
        }

        .msgCodeInput {
          width: calc(100% - 120px);
        }

        .defaultBtn {
          width: 100%;
          max-width: 400px;
          margin: 1.5rem auto;
        }

        .msgCodeBtn {
          width: 110px;
          margin-left: 10px;
        }

        .greenHref {
          font-size: 0.9rem;
          white-space: nowrap;
        }
      }

      .registerTitle {
        font-size: clamp(1.5rem, 4vw, 2rem);
        margin: 1rem 0 2rem;
      }
    }
  }

  .tabTitle {
    flex: 1;
    text-align: center;
    margin: 1rem 0;

    .titleItem {
      display: inline-block;
      padding: 0.8rem 1.5rem;
      cursor: pointer;
      font-size: clamp(0.9rem, 2vw, 1rem);
    }
  }
  .titleActive {
    font-weight: 600;
    border-bottom: 1px solid #262626;
    cursor: default;
  }

  /* 增强响应式处理 */
  @media (max-width: 992px) {
    .register {
      padding: 1rem;

      .content {
        padding: 1rem;
        border-radius: 10px;

        .formWrap {
          padding: 1.5rem;

          .inlineBlock {
            padding: 0.5rem;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .register {
      .content {
        .formWrap {
          .msgCodeInput {
            width: 100%;
            padding-right: 0;
            margin-bottom: 0.5rem;
          }

          .msgCodeBtn {
            width: 100%;
            margin-left: 0;
          }

          .greenHref {
            display: block;
            text-align: center;
            margin: 0.5rem 0;

            &.floatRight {
              float: right;
            }
          }
        }
      }
    }

    .tabTitle {
      .titleItem {
        padding: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    .register {
      .content {
        padding: 0.5rem;

        .formWrap {
          padding: 1rem;

          .inlineBlock {
            padding: 0;
          }
        }
      }
    }

    .titleItem {
      font-size: 0.85rem;
      padding: 0.6rem 0.8rem;
    }
  }

  /* 通用样式优化 */
  .ivu-form-item {
    margin-bottom: 1.5rem;

    &-label {
      font-weight: 500;
      padding: 0.5rem 0 !important;
    }
  }

  .ivu-input {
    height: 45px;
    font-size: 1rem;
    border-radius: 6px;
    transition: all 0.3s;

    &:focus {
      border-color: #4CAF50;
      box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
    }
  }

  .ivu-btn {
    font-weight: 500;
    letter-spacing: 0.05em;
    height: 45px;
    font-size: 1rem;

    &-loading {
      opacity: 0.8;
    }
  }
</style>